module.exports = __webpack_public_path__ + "static/media/6.75479a5e.JPG";